import Translatable from '@/app-core/mixins/translatable'
import CartActions from '@/app-core/mixins/cart/cartActions'
import CartCommon from '@/app-core/mixins/cart/cartCommon'
import WaiterServiceCommon from '@/app-core/mixins/services/waiterServiceCommon'

export default {
  name     : 'QrCodeOrderData',
  mixins   : [Translatable, CartActions, CartCommon, WaiterServiceCommon],
  props    : {},
  dataStore: {
    AppType: 'App.Type'
  },
  data() {
    return {}
  },

  computed: {
    sourceType() {
      return this.$te(`Common.QrSourceType.${this.AppQrData?.type}.Title`) ? this.$t(`Common.QrSourceType.${this.AppQrData.type}.Title`) : ''
    },

    qrValue() {
      return this.AppQrData?.value || ''
    },

    icon() {
      return this.$te(`Common.QrSourceType.${this.AppQrData?.type}.Icon`) ? this.$t(`Common.QrSourceType.${this.AppQrData.type}.Icon`) : 'mdi-information-outline'
    }
  },

  created() {

  },

  methods: {
    showSelectQrItemDialog() {
      this.$bus.$emit('cart:show-dialog', false)
      this.$bus.$emit('select-table:show-dialog')
    },

    clearSessionData() {
      this.clearAppType()
      this.clearQrData()
    },

    toggleWaiterService() {
      if (this.chargeLoading) return

      if (!this.cartWaiterService) {
        this.$bus.$emit('cart:add-service', this.AppWaiterService)
      } else {
        this.$bus.$emit('cart:remove-service', this.AppWaiterService)
      }
    },

    clearQrData() {
      if (!this.AppConfig.Marketplace.CanClearQrData) return

      this.$bus.$emit('cart:show-dialog', false)

      this.$sessionStorage.remove('d')
      this.$sessionStorage.remove('QRData')
      this.$dataStore.App.Type.QrData = null

    },

    clearAppType() {
      if (!this.AppConfig.Marketplace.CanClearAppType) return

      this.$bus.$emit('cart:show-dialog', false)

      this.$sessionStorage.remove('t')
      this.$sessionStorage.remove('d')
      this.$sessionStorage.remove('QRData')
      this.$dataStore.App.Type.QrData = null
      this.$dataStore.App.Type.isQRScanApp = false
    }
  }
}
